<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Lgzv25/tc-custom/9781633536241.jpg?1718183147301" alt="This image is the cover for the book Happy Healthy You"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Happy Healthy You
      </h1>
      <p class="bookDescription body article font2">
        <b>The successful life coach and author of <i>Superior Self</i> offers concrete, easy-to-follow strategies for bringing more health and happiness into your life.</b><br/>  <br/> With our hectic modern lives, it’s easy to feel drained and worn down. But when we stop to consider what’s tapping our energy most, we discover that old habits, unconscious patterns, and past experiences are dragging us down and blocking our self-growth. In <i>Happy Healthy You</i>, life coach KJ Landis helps identify how, why, and where we get ourselves stuck, and how we can utilize the drama and trauma of the past as a springboard to becoming our most authentic, vibrant selves.<br/>  <br/> We all face a lot of stress in our day to day lives. Over time, those stressors can build into a major obstacle, causing us to retreat into survival mode. And when you’re only surviving, you’re not thriving. KJ Landis knows the story all too well—because she lived it herself. Now, she provides the playbook for tackling the blockages in our lives and moving beyond them to a life of happiness and health.<br/>  <br/><b>In this book you will learn:</b><br/> • The root of what keeps us “stuck” in our lives<br/> • How to use the Negative Thought Pot to rid ourselves of self-deprecating beliefs<br/> • How hormones and epigenetics affect mental and physical wellness<br/> • The role of nutrition in our day-to-day health<br/> • Therapeutic movement as a mode of healing<br/> • The power of self-care through restorative practices<br/> • And much, much more!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        KJ Landis
      </h2>
      
      <p class="authorDescription body article">KJ Landis is an author, educator, health, and life coach. She holds a bachelor of science in education, and has certificates in personal training and fitness class instructing, as well as certificates in continuing education in psychology, global health, childhood development, and nutrition at Stanford School of Medicine, Johns Hopkins University, and other prestigious universities. Her focus is on teaching a grain free and sugar free lifestyle, deciphering food labels, and how to build a tribe of support when making any lifestyle change for the better. Landis consults clients locally in San Francisco and remotely via internet and phone, as far as Dubai. She created and facilitates wellness workshops in libraries, senior centers, for corporations, and in private homes. KJ Landis has been a featured guest on HCG Body for Life podcast, Newbie Writers podcast, and more. She has written numerous books on wellness. Her weekly videos and blogs share holistic health topics as well as providing motivational and inspirational support. You may read more about KJ Landis and her personal journey to wellness at SuperiorSelfWithKJLandis.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mango Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ecbde768